import ProgressStatus from 'dashboard/templates/views/Patient/Progress/ProgressStatus';

import journey from './journey';
import parameters from './parameters';

/**
 * Journey progress Status routes
 * @name router.Journey-progress-Status
 */

export default {
  path: 'status',
  name: 'PatientRecordProgressStatus',
  component: ProgressStatus,
  redirect: { name: 'PatientRecordProgressStatusJourney' },
  meta: {
    // title: 'Patient Record - Progress - Status',
    title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  },
  children: [
    journey,
    parameters,
  ],
};
